export const legalEntities = [
  {
    id: '1',
    label: 'Física',
    requiredDocuments: [
      {
        id: '001',
        value:
          'Breve reseña de la empresa (actividad, principales clientes, principales proveedores y demás información útil)',
      },
      {
        id: '002',
        value: 'Declaración de Ganancias',
      },
      {
        id: '009',
        value: 'Último Estado Contable certificado',
      },
      {
        id: '003',
        value: 'Declaración de Bienes Personales',
      },
      {
        id: '004',
        value: 'Ventas Mensuales del Último Año',
      },
      {
        id: '005',
        value: 'Deudas Actualizadas',
      },
      {
        id: '006',
        value: 'Certificado Pyme',
      },
      {
        id: '007',
        value: 'Manifestación de Bienes firmado por contador',
      },
    ],
  },
  {
    id: '2',
    label: 'Jurídica',
    requiredDocuments: [
      {
        id: '001',
        value:
          'Breve reseña de la empresa (actividad, principales clientes, principales proveedores y demás información útil)',
      },
      {
        id: '008',
        value:
          'Detalle de la composición accionaria (indicando CUIT de los socios y %)',
      },
      {
        id: '009',
        value: 'Último Estado Contable certificado',
      },
      {
        id: '010',
        value: 'Ventas Post Balance',
      },
      {
        id: '005',
        value: 'Deudas Actualizadas',
      },
      {
        id: '006',
        value: 'Certificado Pyme',
      },
      {
        id: '007',
        value: 'Manifestación de Bienes firmado por contador',
      },
      {
        id: '011',
        value: 'Estatuto de la empresa',
      },
    ],
  },
  {
    id: '3',
    label: 'SGR',
    requiredDocuments: [
      {
        id: '001',
        value:
          'Breve reseña de la empresa (actividad, principales clientes, principales proveedores y demás información útil)',
      },
      {
        id: '008',
        value:
          'Detalle de la composición accionaria (indicando CUIT de los socios y %)',
      },
      {
        id: '009',
        value: 'Último Estado Contable certificado',
      },
      {
        id: '010',
        value: 'Ventas Post Balance',
      },
      {
        id: '005',
        value: 'Deudas Actualizadas',
      },
      {
        id: '006',
        value: 'Certificado Pyme',
      },
      {
        id: '007',
        value: 'Manifestación de Bienes firmado por contador',
      },
      {
        id: '011',
        value: 'Estatuto de la empresa',
      },
    ],
  },
  {
    id: '4',
    label: 'Financiera',
    requiredDocuments: [
      {
        id: '001',
        value:
          'Breve reseña de la empresa (actividad, principales clientes, principales proveedores y demás información útil)',
      },
      {
        id: '008',
        value:
          'Detalle de la composición accionaria (indicando CUIT de los socios y %)',
      },
      {
        id: '009',
        value: 'Último Estado Contable certificado',
      },
      {
        id: '010',
        value: 'Ventas Post Balance',
      },
      {
        id: '005',
        value: 'Deudas Actualizadas',
      },
      {
        id: '006',
        value: 'Certificado Pyme',
      },
      {
        id: '007',
        value: 'Manifestación de Bienes firmado por contador',
      },
      {
        id: '011',
        value: 'Estatuto de la empresa',
      },
    ],
  },
  {
    id: '5',
    label: 'Persona Fisica Agro',
    requiredDocuments: [
      {
        id: '001',
        value:
          'Breve reseña de la empresa (actividad, principales clientes, principales proveedores y demás información útil)',
      },
      {
        id: '002',
        value: 'Declaración de Ganancias',
      },
      {
        id: '003',
        value: 'Declaración de Bienes Personales',
      },
      {
        id: '004',
        value: 'Ventas Mensuales del Último Año',
      },
      {
        id: '005',
        value: 'Deudas Actualizadas',
      },
      {
        id: '006',
        value: 'Certificado Pyme',
      },
      {
        id: '007',
        value: 'Manifestación de Bienes firmado por contador',
      },
    ],
  },
  {
    id: '6',
    label: 'Persona Juridica Agro',
    requiredDocuments: [
      {
        id: '001',
        value:
          'Breve reseña de la empresa (actividad, principales clientes, principales proveedores y demás información útil)',
      },
      {
        id: '008',
        value:
          'Detalle de la composición accionaria (indicando CUIT de los socios y %)',
      },
      {
        id: '009',
        value: 'Último Estado Contable certificado',
      },
      {
        id: '010',
        value: 'Ventas Post Balance',
      },
      {
        id: '005',
        value: 'Deudas Actualizadas',
      },
      {
        id: '006',
        value: 'Certificado Pyme',
      },
      {
        id: '007',
        value: 'Manifestación de Bienes firmado por contador',
      },
      {
        id: '011',
        value: 'Estatuto de la empresa',
      },
    ],
  },
];
